import React, { useEffect, useState } from 'react'
import SectionHeader from '../../../../Components/GeneralComponents/SectionHeader'
import NewTeamMemberModal from '../../../../Components/Team/NewTeamMemberModal'
import { getTeamMembers, renameTeam } from '../../../../Requests/TeamRequests'
import { PencilSquareIcon } from '@heroicons/react/24/outline'
import TeamMembersTable from '../../../../Components/Team/TeamMembersTable'
import { useTranslation } from 'react-i18next'
import { getTeamUuid } from '../../../../utils/cookies'

function Team() {
    const [teamMemberModal, setTeamMemberModal] = useState(false)
    const [teamMembers, setTeamMembers] = useState(null)
    const [isAdmin, setIsAdmin] = useState(false)
    const [teamName, setTeamName] = useState("")
    const [editingName, setEditingName] = useState(false)
    const [savingName, setSavingName] = useState(false)
    const { t } = useTranslation()

    const handleRename = (event) => {
        event.preventDefault()
        const name = event.target.team_name.value.trim()
        if (!name || name === teamName) {
            setEditingName(false)
            return
        }
        setSavingName(true)
        renameTeam(getTeamUuid(), name).then((res) => {
            setTeamName(res.data.name)
            setEditingName(false)
        }).catch((error) => {

        }).finally(() => {
            setSavingName(false)
        })
    }

    useEffect(() => {
        getTeamMembers(getTeamUuid()).then((res) => {
            setTeamMembers(res.data["members"])
            setIsAdmin(res.data["is_admin"])
            setTeamName(res.data["name"])
        }).catch((error) => {

        });
    }, [])



    return (
        <div className='md:pl-64 pt-4 md:pt-12 w-full flex justify-center px-4'>
            <div className='bg-white max-w-7xl rounded-2xl w-full h-full shadow-xl mx-8'>
                <SectionHeader title={t('Team.Header.Title')} subtitle={t('Team.Header.Subtitle')} actionTitle={t('Team.Header.ActionTitle')} actionFunction={() => { setTeamMemberModal(true) }}></SectionHeader>
                <div className='px-4 pt-6 sm:px-6 lg:px-8'>
                    <label className='block text-sm font-medium text-gray-700'>{t('Team.Header.NameLabel')}</label>
                    {editingName
                        ? <form onSubmit={handleRename} className='mt-1 flex flex-wrap items-center gap-2'>
                            <input
                                type='text'
                                name='team_name'
                                autoFocus
                                defaultValue={teamName}
                                className='w-full max-w-sm rounded-lg border-gray-300 text-sm focus:border-black focus:ring-black'
                            />
                            <button
                                type='submit'
                                disabled={savingName}
                                className='rounded-lg bg-black px-4 py-2 text-sm font-semibold text-white hover:bg-gray-800 disabled:opacity-50'
                            >
                                {t('Team.Header.SaveName')}
                            </button>
                            <button
                                type='button'
                                onClick={() => setEditingName(false)}
                                className='rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-900 hover:bg-gray-50'
                            >
                                {t('Team.Header.CancelName')}
                            </button>
                        </form>
                        : <div className='mt-1 flex items-center gap-2'>
                            <span className='text-lg font-semibold text-gray-900'>{teamName}</span>
                            {isAdmin &&
                                <button
                                    type='button'
                                    title={t('Team.Header.RenameTeam')}
                                    onClick={() => setEditingName(true)}
                                    className='text-gray-500 hover:text-gray-900'
                                >
                                    <PencilSquareIcon className='h-5 w-5' />
                                </button>
                            }
                        </div>
                    }
                </div>
                {teamMembers && <TeamMembersTable teamMembers={teamMembers} isAdmin={isAdmin}></TeamMembersTable>}
            </div>

            {teamMemberModal && <NewTeamMemberModal handleClose={() => { setTeamMemberModal(false) }}></NewTeamMemberModal>}
        </div>
    )
}

export default Team
